import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { admin, guestOtpCodeRoutingModule } from '../guest/otp-code/guest-otp-code.routes';
import { guestRegisterRoutingModule } from '../guest/register/guest-register.routes';
import { guestWelcomeRoutingModule } from '../guest/welcome/guest-welcome.routes';
import { guestAssessmentRoutingModule } from '../guest/assessment/guest-assessment.routes';
import { guestLanguageSelectionRoutingModule } from '../guest/language-selection/guest-language-selection.routes';
import { guestRestrictedRoutingModule } from '../guest/restricted/guest-restricted.routes';

export const guest: Routes = [
  { path: 'guest', redirectTo: 'guest/language-selection', pathMatch: 'full' },
  {
    path: 'guest',
    children: [
      ...guestLanguageSelectionRoutingModule.routes,
      ...guestOtpCodeRoutingModule.routes,
      ...guestRegisterRoutingModule.routes,
      ...guestWelcomeRoutingModule.routes,
      ...guestAssessmentRoutingModule.routes,
      ...guestRestrictedRoutingModule.routes,
    ],
  },
];
@NgModule({
  imports: [RouterModule.forRoot(admin)],
  exports: [RouterModule],
})
export class GuestRoutingModule {
  static routes = admin;
}